<script>
import DatePicker from "vue2-datepicker";
import Drawer from "@/components/drawer";
import moment from "moment";

// Custom Components
import Newkey from "./Newkey.vue";
import DoorLockSocket from "./DoorLockSocket.vue";
import KeyLog from "@/components/lock/KeyLog.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import middlewares from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import { socketConnect } from "@/helpers/webSocketHandler";
import handleLogic from "@/helpers/handleLogic";
import Pagination from "../Pagination.vue";
import roomService from "@/helpers/APIService/room.service";

export default {
  data() {
    return {
      isShowStep: "door_log",
      selectedRoomData: null,
      keyList: [],
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
        totalPages: null,
        currentPage: null,
      },
      isLoading: false,
      selectDate: moment().format("YYYY-MM-DD"),
      isAddNewKey: false,
      selectedKey: null,
      isEdit: false,
      editData: null,
      isOpenDoorDrawerOpen: false,
    };
  },
  props: {
    currentProps: Object,
  },
  computed: {
    ...authComputed,
    doorLockProps() {
      return {
        data: this.selectedRoomData,
        selectedKey: this.selectedKey,
      };
    },
    newKeyProps() {
      return {
        data: {
          from: "doorLock",
          device_id: this.selectedRoomData,
        },
        isEdit: this.isEdit,
        editData: this.editData,
        rfidEncoderList: this.currentProps.rfidEncoderList,
      };
    },
    doorLockSocketProps() {
      return {
        selectedLock: this.selectedRoomData,
        gatewayWebSocketConnection:
          this.currentProps.gatewayWebSocketConnection,
      };
    },
  },
  components: {
    Drawer,
    DatePicker,
    KeyLog,
    Newkey,
    DoorLockSocket,
    Pagination,
  },
  mounted() {
    this.getRoomDetails(this.currentProps.data.id);
    if (this.currentProps.gatewayWebSocketConnection) {
      this.watchGatewaySocket();
    }
    this.$root.$on("lockDataUpdate", (data) => {
      if (data == "door_log") {
        this.isShowStep = "door_log";
      } else {
        this.selectedRoomData = data;
      }
    });
  },
  methods: {
    // Method is used to get room details
    async getRoomDetails(room_id) {
      try {
        const response = await roomService.getRoomDetail(room_id);
        this.selectedRoomData = {
          ...this.currentProps.data,
          ...response,
        };
        this.getDeviceBasedLogList(
          `?size=${this.table.size}&topic=CMD&topic=ALARM`
        );
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to get device based key logs
    async getDeviceBasedLogList(query, status) {
      try {
        this.isLoading = true;
        const filter = `/${this.selectedRoomData.lock_iot_device.id}` + query;
        if (status !== "load_more") {
          this.getKeyListData(
            `?iot_device=${this.selectedRoomData.lock_iot_device.id}&is_active=1`
          );
        }
        const response = await UserService.getKeyLogList(filter);
        if (response) {
          this.table.tableData = [];
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.table.totalPages = response.total_pages;
          this.table.currentPage = response.page_number;
          response.results.map((item) => {
            this.handleResponse(item);
          });
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to get key list
    getKeyListData(query) {
      UserService.getKeyList(query)
        .then((response) => {
          this.keyList = response.results;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to handle add new key
    addNewKey() {
      this.isEdit = false;
      this.editData = null;
      this.isAddNewKey = !this.isAddNewKey;
    },
    // Method is used to handle add new key
    addNewKeyHandle(data, isEdit) {
      if (isEdit) {
        this.keyList = this.keyList.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.keyList.push(data);
      }
      middlewares.notification(
        `${isEdit ? "Edited key" : "New key added"} successfully !!`,
        "success"
      );
      this.addNewKey();
    },
    // Method is used to handle response
    handleResponse(item, method) {
      if (item.topic == "ALARM" || item.topic == "CMD") {
        const data = handleLogic.handleGatewaySocketResponse(
          item,
          this.keyList
        );
        if (method == "shift") {
          this.table.tableData.unshift(data);
        } else {
          this.table.tableData.push(data);
        }
      }
    },
    // Method is used to watch gateway socket
    watchGatewaySocket() {
      if (this.currentProps.gatewayWebSocketConnection.conn.readyState == 3) {
        middlewares.notification("Please try again !!", "info", 2000);
        return (this.currentProps.gatewayWebSocketConnection.conn =
          socketConnect(
            `iot/iot-gateway/${this.currentProps.gatewayWebSocketConnection.id}?token=${this.user.access}`
          ));
      }
      this.currentProps.gatewayWebSocketConnection.conn.onmessage = (event) => {
        const responseData = JSON.parse(event.data);
        this.handleResponse(responseData, "shift");
        if (responseData.topic == "CMD") {
          if (
            responseData.payload.Command == "unlock" ||
            responseData.payload.Command == "emunlock"
          ) {
            if (
              responseData.iot_device ==
              this.selectedRoomData.lock_iot_device.id
            ) {
              if (
                responseData.cmd_response &&
                responseData.cmd_response.Response &&
                responseData.cmd_response.Response.status == "success"
              ) {
                middlewares.notification(
                  "Door unlock successfully !!",
                  "success",
                  2000
                );
              }
            }
          }
        }
        if (responseData.event_type == "device_event") {
          if (
            responseData.lock_iot_device !== null &&
            responseData.id == this.selectedRoomData.lock_iot_device.id
          ) {
            this.selectedRoomData.lock_iot_device = {
              ...this.selectedRoomData.lock_iot_device,
              last_status: responseData.last_status,
              config_data: responseData.config_data,
            };
          }
        }
      };
    },
    // Method is used to unlock door
    unlockRoomDoor(data) {
      if (this.currentProps.gatewayWebSocketConnection) {
        if (this.currentProps.gatewayWebSocketConnection.conn.readyState == 3) {
          middlewares.notification("Please try again !!", "info", 2000);
          return (this.currentProps.gatewayWebSocketConnection.conn =
            socketConnect(
              `iot/iot-gateway/${this.currentProps.gatewayWebSocketConnection.id}?token=${this.user.access}`
            ));
        }
        let seq = Math.floor(1234 + Math.random() * 1051);
        this.currentProps.gatewayWebSocketConnection.conn.send(
          JSON.stringify({
            device_id: data.lock_iot_device.id,
            command: this.user.user.iot_app_setting.is_deadbolt_unlock
              ? "emunlock"
              : "unlock",
            seq: seq,
            params: {},
          })
        );
        middlewares.notification(
          "Command send successfully !!",
          "success",
          2000
        );
      } else {
        middlewares.notification("Please try after sometime !!", "info", 2000);
      }
    },
    // Method is used to open key log
    openKeyLog(key) {
      this.selectedKey = key;
      this.isShowStep = "key_log";
      this.$root.$emit("changeTokey", "key_log");
    },
    // Method is used to update key
    updateKey(key) {
      this.isEdit = true;
      this.editData = key;
      this.isAddNewKey = !this.isAddNewKey;
    },
    // Method is used to handle pagination
    onPageChange(page) {
      this.getDeviceBasedLogList(
        `?page=${page}&size=100&topic=CMD&topic=ALARM`,
        "load_more"
      );
    },
    // Method is used to open door command drawer handle
    openDoorCommandDrawer() {
      this.isOpenDoorDrawerOpen = !this.isOpenDoorDrawerOpen;
    },
    // Method is used to handle tab change
    handleTabClick(status) {
      this.getKeyListData(
        `?iot_device=${this.selectedRoomData.lock_iot_device.id}&is_active=${
          status == "active" ? 1 : 0
        }`
      );
    },
    // Method is used to handle key status change
    handleKeyStatus(key) {
      UserService.updateNewKey(key.id, { is_active: key.is_active })
        .then((response) => {
          if (response) {
            middlewares.notification(
              "Status changed successfully !!",
              "success"
            );
            this.keyList = this.keyList.filter((item) => item.id !== key.id);
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to check lock online or offline
    checkLockStatus(date) {
      return moment().format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD")
        ? moment().diff(date, "minutes") > 30
          ? false
          : true
        : false;
    },
  },
};
</script>

<template>
  <div>
    <div class="row" v-if="isShowStep == 'door_log'">
      <div class="col-xl-9 col-lg-8">
        <div class="card">
          <div class="p-3">
            <div class="row justify-content-end">
              <div class="col-xl-2 col-sm-3 col-6">
                <date-picker
                  lang="en"
                  class="mb-2"
                  placeholder="Select Date"
                  type="date"
                  value-type="format"
                  v-model="selectDate"
                ></date-picker>
              </div>
            </div>
            <div class="table-responsive">
              <v-table
                :data="table.tableData"
                :pageSize="100"
                class="table table-hover mb-0"
                ref="my-table"
              >
                <thead class="table-light" slot="head">
                  <tr>
                    <th class="w-25">timestamp</th>
                    <th class="w-25">Events</th>
                    <th class="w-25">Remark</th>
                    <th class="w-25">User Type</th>
                    <th class="w-25">User Info</th>
                  </tr>
                </thead>
                <tbody
                  class="infinite-list"
                  slot="body"
                  slot-scope="{ displayData }"
                  v-if="!isLoading && table.tableData.length !== 0"
                >
                  <tr v-for="(log, index) in displayData" :key="index">
                    <td>
                      {{
                        global_format_date_and_time_custom(
                          log.created_at,
                          "YYYY-MM-DD hh:mm a"
                        )
                      }}
                    </td>
                    <td class="text-capitalize">
                      {{ log.event }}
                    </td>
                    <td v-if="log.remark !== '-'">
                      <div class="overflow-tip" v-html="log.remark"></div>
                    </td>
                    <td v-else>-</td>
                    <td class="text-capitalize">{{ log.user_type }}</td>
                    <td>
                      {{
                        log.key_info
                          ? log.key_info.booking !== undefined
                            ? log.key_info.booking
                              ? `Unlock by ${log.key_info.booking.first_name} ${log.key_info.booking.last_name} (${log.key_info.booking.reference_no})`
                              : log.key_info.assigned_to
                              ? `Unlock by ${log.key_info.assigned_to.first_name} ${log.key_info.assigned_to.last_name}`
                              : log.rfid_card_id
                              ? log.rfid_card_id
                              : "-"
                            : "-"
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody slot="body" v-else-if="isLoading">
                  <tr v-for="item in 12" :key="item">
                    <td class="placeholder-glow" v-for="no in 5" :key="no">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                </tbody>
                <tbody slot="body" v-else>
                  <tr>
                    <td colspan="9" class="text-center">
                      <img
                        src="@/assets/images/empty.svg"
                        class="img-fluid"
                        alt=""
                      />
                      <p>
                        <span class="text-secondary">No Data Found</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <Pagination
                v-if="table.previous !== null || table.next !== null"
                :totalPages="table.totalPages"
                :currentPage="table.currentPage"
                @pagechanged="onPageChange"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="card">
          <div class="p-3">
            <div
              class="d-flex justify-content-between mb-2"
              v-if="selectedRoomData !== null"
            >
              <h3
                class="cursor"
                @click="openDoorCommandDrawer"
                :class="
                  selectedRoomData.lock_iot_device !== null
                    ? checkLockStatus(
                        selectedRoomData.lock_iot_device.updated_at
                      )
                      ? 'text-success'
                      : 'text-danger'
                    : 'text-primary'
                "
              >
                {{ selectedRoomData.room_number }}
              </h3>
              <i
                class="bx bx-lock fs-2"
                @click="unlockRoomDoor(selectedRoomData)"
                :class="
                  selectedRoomData.lock_iot_device == null
                    ? 'text-secondary'
                    : !selectedRoomData.lock_iot_device.last_status.deadbolt
                    ? 'text-success'
                    : 'text-danger'
                "
              ></i>
              <div class="d-flex justify-content-end">
                <div
                  class="d-flex align-items-center"
                  v-if="selectedRoomData.lock_iot_device !== null"
                >
                  <span class="text-secondary me-1"
                    >{{
                      selectedRoomData.lock_iot_device
                        ? selectedRoomData.lock_iot_device.last_status.battery
                          ? selectedRoomData.lock_iot_device.last_status
                              .battery > 100
                            ? 100
                            : selectedRoomData.lock_iot_device.last_status
                                .battery
                          : "100"
                        : "100"
                    }}%</span
                  >
                  <div
                    class="battery success"
                    v-if="
                      selectedRoomData.lock_iot_device.last_status.battery > 70
                    "
                  >
                    <div
                      class="battery-level"
                      :style="`width: ${selectedRoomData.lock_iot_device.last_status.battery}%`"
                    ></div>
                  </div>
                  <div
                    class="battery warn"
                    v-else-if="
                      selectedRoomData.lock_iot_device.last_status.battery <
                        70 &&
                      selectedRoomData.lock_iot_device.last_status.battery > 30
                    "
                  >
                    <div
                      class="battery-level"
                      :style="`width: ${selectedRoomData.lock_iot_device.last_status.battery}%`"
                    ></div>
                  </div>
                  <div class="battery alert mb-0" v-else>
                    <div
                      class="battery-level"
                      :style="`width: ${selectedRoomData.lock_iot_device.last_status.battery}%`"
                    ></div>
                    <i class="mdi mdi-lightning-bolt alert-leval"></i>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="isLoading">
              <div
                class="card placeholder-glow"
                v-for="no in 7"
                :key="no + 100"
              >
                <div class="p-3">
                  <div class="placeholder w-100 placeholder-lg p-4"></div>
                </div>
              </div>
            </template>
            <div
              class="card"
              v-if="!isLoading && user.user.iot_app_setting.is_set_guest_key"
              @click="addNewKey"
            >
              <div class="card-body">
                <a href="javascript: void(0);">
                  <div class="text-center">
                    <label for="" class="fs-5">Create New Key</label>
                  </div>
                  <i class="fas fa-plus fs-3 d-block text-center"></i>
                </a>
              </div>
            </div>
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-2 text-muted"
            >
              <b-tab active @click="handleTabClick('active')">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Active Keys</span>
                </template>
              </b-tab>
              <b-tab @click="handleTabClick('not-active')">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Inactive Keys</span>
                </template>
              </b-tab>
            </b-tabs>
            <template v-if="!isLoading && keyList.length !== 0">
              <div class="card" v-for="(key, index) in keyList" :key="index">
                <div class="p-3 cursor">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <p class="mb-2">
                        {{
                          key.key_type == "rfid"
                            ? "RFID KEY"
                            : key.key_type == "mobile"
                            ? "MOBILE KEY"
                            : key.key_type == "key_code"
                            ? "KEY CODE"
                            : "STAFF Group A"
                        }}
                      </p>
                      <img
                        src="@/assets/images/rfid-key-icon.png"
                        alt="rfid-key"
                        class="me-2"
                        v-if="key.key_type == 'rfid'"
                      />
                      <img
                        src="@/assets/images/mobile-key-icon.png"
                        alt="rfid-key"
                        class="me-2"
                        v-else-if="key.key_type == 'mobile'"
                      />
                      <img
                        src="@/assets/images/key-code-icon.png"
                        alt="rfid-key"
                        class="me-2"
                        v-else
                      />
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="text-end">
                        <p class="mb-2">{{ key.rfid_card_id }}</p>
                        <p class="mb-2">
                          {{
                            global_format_date_and_time_custom(
                              key.start_datetime,
                              "MMM DD, hh:mm"
                            )
                          }}
                          to
                          {{
                            global_format_date_and_time_custom(
                              key.expire_datetime,
                              "MMM DD, hh:mm"
                            )
                          }}
                        </p>
                        <b-form-group label-for="is_deadbolt_enable">
                          <div
                            class="form-check form-switch d-flex justify-content-end"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="is_deadbolt_enable"
                              v-model="key.is_active"
                              @change="handleKeyStatus(key)"
                            />
                          </div>
                        </b-form-group>
                        <i
                          class="fas fa-book text-success fs-4"
                          v-if="key.booking !== null"
                          v-b-popover.hover="
                            `${key.booking.last_name} ${key.booking.first_name} (${key.booking.reference_no})`
                          "
                        ></i>
                      </div>
                      <b-dropdown
                        class="float-end ms-2"
                        toggle-class="text-muted p-0"
                        menu-class="dropdown-menu-end"
                        right
                        variant="white"
                        v-if="
                          key.key_type == 'rfid' ||
                          key.key_type == 'mobile' ||
                          key.key_type == 'key_code'
                        "
                      >
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-vertical font-size-24"></i>
                        </template>
                        <b-dropdown-item @click="openKeyLog(key)"
                          >Open Key Log</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-show="!user.user.iot_app_setting.is_set_guest_key"
                          @click="updateKey(key)"
                          >Edit Key</b-dropdown-item
                        >

                        <b-dropdown-item v-if="key.key_type == 'rfid'"
                          >Extend Key</b-dropdown-item
                        >
                        <b-dropdown-item v-if="key.key_type == 'mobile'"
                          >Resend</b-dropdown-item
                        >

                        <b-dropdown-item>Delete Key</b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- Components is used to display key logs -->
    <KeyLog v-if="isShowStep == 'key_log'" :currentProps="doorLockProps" />
    <!-- Drawer is used to add new RFID Key -->
    <Drawer
      @close="addNewKey"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :maxWidth="675"
      :zIndex="1002"
    >
      <div v-if="isAddNewKey">
        <Newkey
          :currentProps="newKeyProps"
          @submitted="addNewKeyHandle"
          @cancelSubmit="addNewKey"
        />
      </div>
    </Drawer>
    <!-- Drawer is used to handle door lock commad -->
    <Drawer
      @close="openDoorCommandDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isOpenDoorDrawerOpen">
        <DoorLockSocket :currentProps="doorLockSocketProps" />
      </div>
    </Drawer>
  </div>
</template>
